import getParent from '../selectors';

export const getPrimaryParameterLevel = state =>
  getParent(state).primaryParameterLevel;

export default getPrimaryParameterLevel;
